class RequestCounter {
    constructor() {
      this.count = 0;
      this.listeners = new Set();
    }
  
    increment() {
      this.count++;
      this.notify();
    }
  
    decrement() {
      this.count = Math.max(0, this.count - 1);
      this.notify();
    }
  
    subscribe(fn) {
      this.listeners.add(fn);
      fn(this.count);
      return () => this.listeners.delete(fn);
    }
  
    notify() {
      for (const fn of this.listeners) {
        fn(this.count);
      }
    }
  }
  
  export const requestCounter = new RequestCounter();
  